import io from "socket.io-client";
import api from "./api";

class SocketWorker {
  constructor(companyId , userId) {
    if (SocketWorker.instance && (Number(SocketWorker.instance.companyId) !== Number(companyId) || Number(SocketWorker.instance.userId) !== Number(userId))) {
      SocketWorker.instance.disconnect();
    }
    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.socket = null;
      this.disposed = false;
      this.configureSocket();
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
      SocketWorker.instance = this;

    } 

    return SocketWorker.instance;
  }

  configureSocket() {
    if (this.disposed) return;
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      auth: async callback => {
        let token;
        const authorization = api.defaults.headers.Authorization;
        if (typeof authorization === "string" && authorization.startsWith("Bearer ")) token = authorization.slice(7);
        else { try { token = JSON.parse(localStorage.getItem("token")); } catch { token = null; } }
        let expiresAt;
        try { expiresAt = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))).exp; } catch { expiresAt = null; }
        if (typeof expiresAt === "number" && expiresAt * 1000 <= Date.now()) {
          try {
            const { data } = await api.post("/auth/refresh_token");
            token = data.token;
            localStorage.setItem("token", JSON.stringify(token));
            api.defaults.headers.Authorization = `Bearer ${token}`;
          } catch { token = null; }
        }
        callback({ token });
      },
      query: { userId: this.userId }
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", () => {
      console.log("Desconectado do servidor Socket.IO");
      this.reconnectAfterDelay();
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {
    if (this.disposed) return;
    this.connect();
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    if (this.disposed) return;
    this.connect();
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    if (this.disposed || !this.socket) return;
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    this.disposed = true;
    clearTimeout(this.reconnectTimer);
    if (SocketWorker.instance === this) SocketWorker.instance = null;
    if (this.socket) {
      this.socket.removeAllListeners();
      this.socket.disconnect();
      this.socket = null
      console.log("Socket desconectado manualmente");
    }
    this.eventListeners = {};
  }

  reconnectAfterDelay() {
    this.reconnectTimer = setTimeout(() => {
      if (!this.disposed && (!this.socket || !this.socket.connected)) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (this.disposed) return;
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;
